import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderLicensureDataSchema } from './ServicesProviderLicensureData.js';

class ServicesProviderLicensure extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderLicensureDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderLicensure.validation', `ServicesProviderLicensure data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.LICENSURE,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.LICENSURE, ServicesProviderLicensure);

export { ServicesProviderLicensure };
//# sourceMappingURL=ServicesProviderLicensure.js.map
